import React from "react";
import s from "./style.module.css";
// import doctor from "../../../assets/images/characters/doctor.png";
import doctorWave from "../../../assets/video/doctorWave2.gif";

const styles = {
  normalText: {
    fontSize: "1.45vmax",
    color: "#000000",
  },
  highlightText: {
    fontSize: "2.45vmax",
    color: "#1C77FF",
  },
};
const Content = ({ item, contentID }) => {
  return (
    <React.Fragment>
      {contentID === 1 ? null : (
        <React.Fragment>
          <img
            className={s.CharacterWrapper}
            src={!!item.img ? item.img : doctorWave}
            alt="character"
          />
          {/* {!!item.img ? (
            <img
              className={s.CharacterWrapper}
              src={item.img}
              alt="character"
            />
          ) : (
            <video className={s.CharacterWrapper2} autoPlay loop muted>
              <source src={doctor3} />
            </video>
          )} */}
        </React.Fragment>
      )}

      {item.header ? (
        <h1>{item.label1.text}</h1>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={
              item.label1.highlight ? styles.highlightText : styles.normalText
            }
          >
            {item.label1.text}
          </span>
          {!!item.label2 && (
            <span
              style={
                item.label2.highlight ? styles.highlightText : styles.normalText
              }
            >
              {item.label2.text}
            </span>
          )}
          {!!item.label3 && (
            <span
              style={
                item.label3.highlight ? styles.highlightText : styles.normalText
              }
            >
              {item.label3.text}
            </span>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default Content;
